module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Rheinfelden_AG-10b19990b8463e7b070ae0fb36a09836.svg";